<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <avue-crud
    :option="option"
    :table-loading="loading"
    :data="data"
    :page.sync="page"
    ref="crud"
    @on-load="onLoad"
    @current-change="currentChange"
    @size-change="sizeChange"
    @refresh-change="onLoad"
    @selection-change="selectionChange"
  >
  <template slot="menuLeft">
      <el-button
       v-if="model != 'view'"
        type="primary"
        icon="el-icon-plus"
        size="small"
        @click="addRecord"
      >
        新 增</el-button
      >
    </template>
    <template slot-scope="scope" slot="menu" v-if="model != 'view'">
        <el-button type="text" size="small"  @click="editRecord(scope.row)">编辑 </el-button>
        <el-button type="text" size="small"  @click="deleteRecord(scope.row)">删除 </el-button>
      </template>
  </avue-crud>
    </div>
    <hr-dialog :title="formTitle" :allowFull="false" width="60%" :visible.sync="healthTreatFormVisible">
    <template slot="body">
      <healthTreatForm
        :model="formModel"
        :row="formRow"
        @cancle="recordCancle"
        v-if="healthTreatFormVisible"
        @success="recordSuccess"
        :personData="row"
      ></healthTreatForm>
    </template>
  </hr-dialog>
  </div>
</template>
  <script>

import healthTreatForm from './healthTreatForm.vue';
import { getHealthVisitPage,removeHealthVisit } from '@/api/nursingHome/healthData.js';
export default {
  components: {healthTreatForm},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      healthTreatFormVisible:false,
      formRow:{},
     data:[],
     formTitle:'新增',
     formModel:"add",
     option: {
      selection: false,
      select: true,
      index: true,
      indexLabel: '#',
      page: true,
      height: 'auto',
      calcHeight: 'auto',
      align: 'left',
      menu: this.model != 'view',
      addBtn: false,
      editBtn: false,
      delBtn: false,
      border: true,
      column: [
        {
          label: '姓名',
          prop: 'elderlyName',
        },
        {
          label: '手机号',
          prop: 'phone',
        },
        {
          label: '主要症状',
          prop: 'mainSymptoms',
        },
        {
          label: '处理',
          prop: 'handle',
        },

        {
          label: '就诊日期',
          prop: 'visitDate',
        },
        {
          label: '出诊医生',
          prop: 'visitDoctor',
        },
        {
          label: '医疗费用',
          prop: 'medicalFee',
        },

      ],
    },
    page: {
      pageSize: 10,
      currentPage: 1,
      total: 0,
    },
    loading: false,
    searchForm:{}
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    addRecord(row){
      this.formTitle ="新增"
      this.formModel ="add"
      this.formRow = row
      this.healthTreatFormVisible =true
    },

    editRecord(row){
      this.formTitle ="编辑"
      this.formModel ="edit"
      this.formRow = row
      this.healthTreatFormVisible =true
    },
    deleteRecord(row){
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        removeHealthVisit(row.id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.onLoad();
        });
      });
    },
     initData() {
      this.searchForm.nursinghomeId =this.row.nursinghomeId
      this.searchForm.elderlyId = this.row.id

    },
    recordCancle(){
      this.healthTreatFormVisible =false
    },
    recordSuccess(){
      this.healthTreatFormVisible =false
      this.onLoad()
    },
    onLoad(){
      getHealthVisitPage(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize },
          this.searchForm
        )
      )
        .then(({ data }) => {
          this.data =data.records
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }

  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
